export default __webpack_public_path__ + "static/media/rdc-logo.d7c1ff7e.png";